import URLS from '@Src/commons/ConstantUrls';
import { isEmail } from '@Src/commons/Validations';
import {
  TypeLoginWithIpAddress,
  TypeLoginWithMobile,
  TypeSignupWithCaptcha,
  TypeUserAdminData,
} from '@Src/components/Auth/AuthProps';
import {
  getUIResourcesURL,
  logoutURL,
  resetPasswordEmail,
} from '@Src/commons/DynamicUrls';
import { getAppSource } from '@Src/commons/Utils';
import { getUserId } from '@Src/commons/Utils/authUtils';
import {
  AuthVerifyApiResponse,
  TypeRestFormWithToken,
} from './ApiProps/ServicesProps';
import {
  deleteRequestUms,
  getUms,
  makeRequest,
  postUms,
  putUms,
} from './baseService';

const APP_SOURCE = getAppSource();

const getHeaders = (email: string, password: string) => {
  let authdata = '';
  if (isEmail(email)) {
    authdata = btoa(`${email}:${password}`);
  } else {
    // change the country code
    const countryExtensionCode = '+91';
    authdata = btoa(`${countryExtensionCode}${email}:${password}`);
  }
  return {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    Authorization: `Basic ${authdata}`,
    Type: 'access_token',
    Source: APP_SOURCE,
    IdentityProvider: 'password',
  };
};

// login
export const loginAPI = (data: TypeLoginWithIpAddress) => {
  const options = {
    method: 'POST',
    headers: getHeaders(data.email, data.password),
  };

  return makeRequest({ url: URLS.AUTH_VERIFY, options, umsRequest: true })
    .then((response: AuthVerifyApiResponse) => response)
    .catch((err) => {
      throw err;
    });
};

// login with mobile
export const loginWithMobileAPI = (data: TypeLoginWithMobile) =>
  postUms({
    url: URLS.AUTH_VERIFY,
    headers: {
      IdentityProvider: 'otp',
    },
    data,
  });

// signup
export const simpleSignupAPI = (data: TypeSignupWithCaptcha) =>
  postUms({
    url: URLS.CREATE_USER,
    headers: getHeaders(data.email, data.password),
    data,
  });

// google signup
export const googleSignupAPI = (token: string) =>
  postUms({
    url: URLS.AUTH_VERIFY,
    headers: {
      Authorization: `${token}`,
      IdentityProvider: 'google',
      Source: APP_SOURCE,
    },
  });

// update user admin data(name, phone number)
export const updateUserAdminDataAPI = (data: TypeUserAdminData) =>
  postUms({
    url: URLS.UPDATA_NEW_USER,
    data,
  });
// refresh JWT token
export const refreshJWTTokenAPI = () =>
  getUms({
    url: URLS.REFRESH_JWT_TOKEN,
  });

export const getUIResourcesAPI = (userId: string) =>
  getUms({
    url: getUIResourcesURL(userId),
  });

export const forgotPasswordApi = (email: string, reCaptchaToken: string) =>
  postUms({
    data: { email, reCaptchaResponse: reCaptchaToken },
    url: resetPasswordEmail(),
  });

export const resetPasswordApi = (payload: TypeRestFormWithToken) =>
  postUms({
    url: URLS.RESET_PASSWORD,
    data: payload,
  });

export const validateResetPasswordTokenAPI = (token: string) =>
  getUms({
    url: URLS.VALIDATE_RESET_PASSWORD_TOKEN,
    params: {
      reset_password_token: token,
    },
  });

export const oneClickSignupAPI = (payload) =>
  postUms({
    url: URLS.ONE_CLICK_SIGNUP,
    data: payload,
  });

export const checkActiveGstinAPI = (gstin: string) =>
  getUms({
    url: `credentials/einvoice/isactive/${gstin}`,
  });

export const logoutAPI = (userId: string) =>
  putUms({
    url: logoutURL(userId),
  });

export const fetchHmacData = (userId: string) =>
  getUms({
    url: `user/${userId}/hmac-signature`,
  });

export const fetchSessions = () =>
  getUms({
    url: `api/users/fetch-sessions`,
  });

export const terminateSessions = (sessionId: string, sessionToken: string) =>
  getUms({
    url: `api/users/session/terminate/${sessionId}?sessionToken=${encodeURIComponent(
      sessionToken
    )}`,
    data: {},
  });
export const logoutSessions = (session_id = '') => {
  const userId = getUserId();
  if (userId) {
    return deleteRequestUms({
      url: `api/users/session/logout/${userId}?sessionId=${session_id}`,
      data: {},
    });
  }
  return Promise.resolve(true);
};
